import React from 'react';
import './ProgramDetails.css';
import Background from "../assets/splash-bg.jpg";
import RegistrationPoster from "../assets/registration-poster.jpg";
import Speaker1 from "../assets/Speaker1.png";
import Speaker2 from "../assets/Speaker2.png";
import Speaker3 from "../assets/Speaker3.png";
import Speaker4 from "../assets/Speaker4.png";
import Speaker5 from "../assets/Speaker5.png";
import Speaker6 from "../assets/Speaker6.png";
import Speaker7 from "../assets/Speaker7.png";
import Speaker8 from "../assets/Speaker8.png";
import Speaker9 from "../assets/Speaker9.png";
import FridaySchedule from "../assets/friday-schedule.png";
import SaturdaySchedule from "../assets/saturday-schedule.png";
import Footer from './Footer.tsx';

const ProgramDetails = () => {
  return (
    <div className="program-details-container">
      {/* Header Section */}
      <div 
        className="program-hero-section" 
        style={{ backgroundImage: `url(${Background})` }}
      >
        <div className="program-overlay"></div>
        <div className="program-content">
          <div className="program-title-section">
            <h1 className="program-page-title">PROGRAM DETAILS</h1>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {/* Theme Section */}
        <div className="theme-section">
          <h2 className="section-title">THIS YEAR'S THEME IS...</h2>
          
          <div className="theme-grid">
            <div className="theme-image-column">
              <img 
                src={RegistrationPoster} 
                alt="Voices of Virtue 2025 - Finding Our Way: The Lighthouse of Faith" 
                className="theme-poster"
              />
            </div>
            
            <div className="theme-text-column">
              <p className="theme-description">
                In times of confusion, change, and spiritual drift, the heart yearns for 
                clarity and direction. This year's theme, <strong>"Finding Our Way: The 
                Lighthouse of Faith"</strong>, calls us to anchor ourselves in divine 
                guidance—using the Qur'an and Sunnah as our compass amid life's 
                turbulent seas. Like a lighthouse illuminating the path for weary 
                travelers, faith offers constancy, hope, and vision.
              </p>
              <p className="theme-description">
                Through this theme, we will explore how to rekindle spiritual 
                awareness, revive the heart, and find steady ground through prayer, 
                companionship, and purposeful growth. Whether you're seeking 
                direction, healing, or deeper conviction, this year's conference is an 
                invitation to journey back to the light of Allah.
              </p>
            </div>
          </div>
        </div>

        {/* Speakers Section */}
        <div className="content-section">
          <h2 className="section-title">SPEAKERS LINE-UP</h2>
          
          <ul className="speakers-list">
            <li>
              <strong>Opening:</strong> The Lighthouse of Guidance <em></em>
            </li>
            <li>
              <strong>Session #1:</strong> Types of Souls: Understanding the Inner Struggle <em></em>
            </li>
            <li>
              <strong>Session #2:</strong> Attaining Khushu' in Prayer: The Key to a Lit Path <em></em>
            </li>
            <li>
              <strong>Brother's Breakout Session:</strong> Navigating Storms: Masculinity, Responsibility, and Spiritual Leadership<em></em><em></em>
            </li>
            <li>
              <strong>Sister's Breakout Session:</strong> Navigating Storms: Femininity, Accountability, and Growing Communities <em></em> <em></em>
            </li>
            <li>
              <strong>Session #3:</strong> The Ayah of Hope: A Lifeline for the Lost <em></em>
            </li>
            <li>
              <strong>Session #4:</strong> Reviving a Dead Heart: Harder Than Stone to Flesh<em></em>
            </li>
            <li>
              <strong>Closing:</strong> Steady Sailing: Embracing Gradual Growth <em></em>
            </li>
            <li>
              <strong>Note:</strong> More information coming soon, check Instagram for latest details<em></em>
            </li>
          </ul>
        </div>
        {/* Speaker Photos Grid */}
        {/*
        <div className="speakers-photos-section">
          <div className="speakers-grid">
            <img src={Speaker1} alt="Speaker 1" className="speaker-photo" />
            <img src={Speaker2} alt="Speaker 2" className="speaker-photo" />
            <img src={Speaker3} alt="Speaker 3" className="speaker-photo" />
            <img src={Speaker4} alt="Speaker 4" className="speaker-photo" />
            <img src={Speaker5} alt="Speaker 5" className="speaker-photo" />
            <img src={Speaker6} alt="Speaker 6" className="speaker-photo" />
            <img src={Speaker7} alt="Speaker 7" className="speaker-photo" />
            <img src={Speaker8} alt="Speaker 8" className="speaker-photo" />
            <img src={Speaker9} alt="Speaker 9" className="speaker-photo" />
          </div>
        </div>
        */}
        {/* Schedule Section */}
        
        {/* <div className="content-section">
          <h2 className="section-title">TENTATIVE SCHEDULE</h2>
           */}
          

          {/* <div className="schedule-grid"> */}
            {/* <div className="schedule-item">
              <img 
                src={FridaySchedule} 
                alt="Friday October 3rd Schedule" 
                className="schedule-image"
              />
            </div> */}
            {/* <div className="schedule-item"> */}
              {/* <img 
                src={SaturdaySchedule} 
                alt="Saturday October 4th Schedule" 
                className="schedule-image"
              /> */}
            {/* </div> */}
          {/* </div> */}
          
          {/* <div className="program-link-section">
            <p className="program-link-text">To access the full schedule, click the link below</p>
            <a 
              href="https://docs.google.com/spreadsheets/d/1xzPN7VZHUSIlHKSyz5vC8tUP2g-Va4jliYdGjZnANVY/edit?usp=sharing"
              target="_blank" 
              rel="noopener noreferrer"
              className="program-document-btn"
            >
              Full Program Document
            </a>
          </div> */}
        {/* </div> */}
      </div>
      <Footer />
    </div>
  );
};

export default ProgramDetails;